module.exports = "/_next/static/images/table-ac0a726e22573a70e6192837c0b29723.svg";